import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana15Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1467_36694)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M810.416 400.699L732.74 386.757L718.798 394.724L752.657 462.441L818.382 428.582C826.349 412.649 816.391 403.354 810.416 400.699Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M694.9 492.312L752.659 462.436L718.8 394.719L661.041 424.594L694.9 492.312Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M606.552 356.878L730.037 386.753L630.452 436.546L596.593 362.853L606.552 356.878Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M637.141 520.197L694.9 492.314L661.041 422.604L603.282 452.48L637.141 520.197Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M542.819 388.746L596.595 362.854L630.453 436.547L578.669 462.439L542.819 388.746Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M579.384 548.078L637.143 520.194L603.284 452.477L545.525 480.36L579.384 548.078Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M489.046 414.634L542.822 388.742L578.673 462.435L522.905 488.327L489.046 414.634Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M519.638 577.956L579.388 548.081L545.53 480.363L485.779 508.247L519.638 577.956Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M435.268 438.537L489.044 414.637L522.902 490.321L469.127 514.221L435.268 438.537Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M461.875 605.838L519.634 577.954L485.776 508.245L428.017 534.137L461.875 605.838Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M384.196 464.431L437.971 438.539L471.83 514.223L418.055 538.124L384.196 464.431Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M330.425 490.32L384.2 464.428L418.059 538.12L364.284 564.012L330.425 490.32Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M402.125 631.735L461.876 605.843L428.017 534.143L370.258 562.026L402.125 631.735Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M358.306 651.646L402.124 631.729L370.257 562.02L308.514 589.903L332.414 643.679C338.788 656.426 352.331 654.301 358.306 651.646Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M286.602 510.238L330.419 490.321L364.282 564.014L308.514 589.906L282.619 534.139C276.245 521.392 282.619 512.894 286.602 510.238Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_36694" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_36694" transform="matrix(0.00273194 0 0 0.00362182 -6.00844 -1.48608)"/>
    </pattern>
    <image id="image0_1467_36694"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};